import React, { ReactNode } from "react";
import styled from "@emotion/styled";
import { useTheme } from "@cbex/utils/theme";
import { WcCheckBox, WcCheckBoxProps } from "@bpipartners/webui";
type CustomCheckBoxComponentProps = WcCheckBoxProps & {
  controldisabled?: boolean;
  children?: ReactNode;
};

const CustomCheckBox = styled(WcCheckBox)(({ theme }) => ({
  "&.Mui-disabled": {
    color:
      //@ts-ignore
      theme.palette.primary.main,
    pointerEvents: "unset",
    "&&:hover": {
      cursor: "default",
    },
  },
}));

export const CustomCheckBoxComponent = ({
  controldisabled = false,

  ...props
}: CustomCheckBoxComponentProps) => {
  const theme = useTheme();
  return (
    //@ts-ignore
    <CustomCheckBox
      size="small"
      theme={theme}
      {...props}
      disableRipple={controldisabled}
      disabled={controldisabled}
    />
  );
};

export default CustomCheckBoxComponent;
